"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const distance = ({ latitudeOrigin, longitudeOrigin, latitudeDestination, longitudeDestination, unit, }) => {
    if ((latitudeOrigin === latitudeDestination) && (longitudeOrigin === longitudeDestination)) {
        return 0;
    }
    const radlat1 = (Math.PI * latitudeOrigin) / 180;
    const radlat2 = (Math.PI * latitudeDestination) / 180;
    const theta = longitudeOrigin - longitudeDestination;
    const radtheta = (Math.PI * theta) / 180;
    let dist = Math.sin(radlat1) * Math.sin(radlat2)
        + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === 'K') {
        dist *= 1.609344;
    }
    if (unit === 'N') {
        dist *= 0.8684;
    }
    return dist;
};
exports.default = distance;
